import React from 'react';
import { Autocomplete, TextField, CircularProgress, Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

// Styled component for enhanced visual effects
const StyledAutocomplete = styled(Autocomplete)(({ theme }) => ({
  '& .MuiInputBase-root': {
    transition: theme.transitions.create(['border-color', 'box-shadow', 'background-color']),
    '&:hover': {
      backgroundColor: theme.palette.mode === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    },
    '&.Mui-focused': {
      boxShadow: `0 0 0 2px ${theme.palette.primary.light}`,
    },
  },
}));

const MagicAutocompleteVendor = ({
  label = "Vendor",
  value,
  onChange,
  inputValue,
  onInputChange,
  options = [],
  loading = false,
  error = false,
  helperText = '',
  required = false,
  ...props
}) => {
  return (
    <StyledAutocomplete
      value={value}
      onChange={onChange}
      inputValue={inputValue}
      onInputChange={onInputChange}
      options={options}
      loading={loading}
      getOptionLabel={(option) => {
        if (!option) return '';
        return option.name || '';
      }}
      isOptionEqualToValue={(option, value) => {
        if (!option || !value) return false;
        return option._id === value._id;
      }}
      renderOption={(props, option) => (
        <Box component="li" {...props}>
          {option.isCreateNew ? (
            <Typography color="primary">+ {option.name}</Typography>
          ) : (
            option.name
          )}
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          required={required}
          error={error}
          helperText={helperText}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
      // Disable default filtering since we're doing server-side search
      filterOptions={(x) => x}
      {...props}
    />
  );
};

export default MagicAutocompleteVendor;